import { render, staticRenderFns } from "./CloseButton.vue?vue&type=template&id=bf9ab0d2"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf9ab0d2')) {
      api.createRecord('bf9ab0d2', component.options)
    } else {
      api.reload('bf9ab0d2', component.options)
    }
    module.hot.accept("./CloseButton.vue?vue&type=template&id=bf9ab0d2", function () {
      api.rerender('bf9ab0d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sidebar/CloseButton.vue"
export default component.exports